var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 17.0003C11.7443 17.0003 11.4883 16.9023 11.2933 16.7073L4.29325 9.70731C3.90225 9.31631 3.90225 8.68425 4.29325 8.29325C4.68425 7.90225 5.31631 7.90225 5.70731 8.29325L12.0003 14.5862L18.2933 8.29325C18.6842 7.90225 19.3163 7.90225 19.7073 8.29325C20.0983 8.68425 20.0983 9.31631 19.7073 9.70731L12.7073 16.7073C12.5123 16.9023 12.2563 17.0003 12.0003 17.0003Z",
    fill: "#B1B5C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.8908ca72a42c272beade25e0af3e7c1f.svg";
export { ForwardRef as ReactComponent };